import { api } from '@/plugins'
import {
  GET_QUESTIONNAIRES,
  GET_QUESTIONNAIRES_SUCCESS,
  GET_QUESTIONNAIRES_FAIL
} from './mutations'

export default {
  list({ commit }) {
    return new Promise((resolve, reject) => {
      commit(GET_QUESTIONNAIRES)
      api
        .GET('bienetre/list')
        .then(async (quests) => {
          await commit(GET_QUESTIONNAIRES_SUCCESS, quests)
          resolve(quests)
        })
        .catch((e) => {
          commit(GET_QUESTIONNAIRES_FAIL)
          reject(e)
        })
    })
  }
}
